export class CampaignsFilterModel {
    constructor(
        public brand: string = '',
        public product: string = '',
        public dsp: string = '',
        public ssp: string = '',
        public tradingDesk: string = '',
        public isAvailable: boolean,
        public countryIds: Array<number>,
        public providerIds: Array<number>,
        public publisherIds: Array<number>,
        public startDate?: Date,
        public endDate?: Date) {
    }
}


// WEBPACK FOOTER //
// ./src/app/campaigns/campaign-filter.model.ts